(() => {
  const placeShare = () => {
    if (!document.body.classList.contains('template-product')) return true;
    if (document.querySelector('[data-wewok-share-on]:not([hidden])')) return true;

    const source = document.querySelector('[data-wewok-share-source]');
    const section = source && source.firstElementChild;
    if (!source || !section) return false;

    const anchor = document.querySelector('.product-form__buttons')
      || document.querySelector('.shopify-payment-button')
      || document.querySelector('form[action*="/cart/add"]')
      || document.querySelector('[data-gokwik-buy-now]');

    if (!anchor) return false;

    const target = anchor.closest('.product-form__buttons') || anchor;
    target.insertAdjacentElement('afterend', section);
    source.remove();
    return true;
  };

  const start = () => {
    if (placeShare()) return;

    let tries = 0;
    const timer = window.setInterval(() => {
      tries += 1;
      if (placeShare() || tries >= 10) window.clearInterval(timer);
    }, 150);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
